<template>
  <div class="scenario_container">
    <div class="parent_nodes flex">
      <div
        class="parent_node flex"
        :class="tab_one_cur == ind ? 'act' : ''"
        v-for="(item, ind) in nodes_list"
        @click="changeCurInd(ind)"
        :key="ind"
      >
        <div class="icon" :class="'icon_' + nodes_type[item.node_id]"></div>
        <div class="node_name">{{ item.node_name }}</div>
      </div>
    </div>
    <div class="nodes_container" v-if="nodes_list && nodes_list[tab_one_cur]">
      <div class="node_tabs flex">
        <div
          class="node_tab"
          :class="tab_two_cur == -1 ? 'act' : ''"
          @click="changeCurInd2(-1)"
        >
          综合
        </div>
        <div
          class="node_tab"
          :class="tab_two_cur == ind ? 'act' : ''"
          v-for="(item, ind) in nodes_list[tab_one_cur].child"
          :key="ind"
          @click="changeCurInd2(ind)"
        >
          {{ item.node_name }}
        </div>
      </div>
      <div class="videos_box">
        <div class="node_videos flex">
        <div
          class="node_video"
          v-for="(item, ind) in video_list"
          :key="ind"
          
        >
          
          <template v-if="(route_type=='drive'?item.attach_value:item.link_url).indexOf('.jpg')>-1 || (route_type=='drive'?item.attach_value:item.link_url).indexOf('.jpeg')>-1 || (route_type=='drive'?item.attach_value:item.link_url).indexOf('.png')>-1">
            <div class="video_box">            
              <el-image
                style="width: 100%; height: 100%"
                :src="(route_type=='drive'?item.attach_value:item.link_url+ '?x-oss-process=image/resize,w_236')"
                :preview-src-list="[(route_type=='drive'?item.attach_value:item.link_url)]"
                fit="cover"
              />
            </div>
          </template>
          <div class="video_box" v-else>
            <video controlsList="nodownload"
              :src="(route_type=='drive'?item.attach_value:item.link_url)"
              :poster="
                (route_type=='drive'?item.attach_value:item.link_url) +
                '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'
              "
              preload="none"
              @click="playVideo(item)"
              ></video>
            </div>
            <div class="node_name" v-if="item.attach_name || item.node_name" @click="playVideo(item)">
              {{item.attach_name || item.node_name}}
            </div>
            <div class="model_name flex" @click="playVideo(item)">
              <div class="brand_logo" v-if="item.brand_logo" >
                <img :src="item.brand_logo" />
              </div>
              <div>{{ item.model_name }}</div>
            </div>
          </div>
        </div>
        <div class="no_more" v-if="total_page<cur_page">没有更多了~</div>
        <div class="load_more" v-else @click="getVideos">加载更多···</div>
      </div>
      
    </div>

    <div class="video_pop" v-show="video_show">
      <div class="video_content">
        <video controlsList="nodownload"
          :src="video_src"
          autoplay
          controls
          :poster="
            video_src +
            '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'
          "
          preload="metadata"
        ></video>
        <div class="video_close" @click="stopVideo"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { ElImage } from "element-plus";
import { getParentNodes, getNodeVideos } from "@/api_drive";
import {
  getParentNodes as getParentNodes2,
  getNodeVideos as getNodeVideos2,
} from "@/api";

export default {
  props: {
    route_type: {
      default: "",
    },
  },
  components:{
    ElImage
  },
  setup(props) {
    const nodes_type = {
      6061: 1,
      6062: 1,
      6063: 1,
      6064: 2,
      6065: 2,
      6066: 2,
      6067: 2,
      6068: 3,
      6069: 3,
      6070: 3,
      6071: 3,
      6072: 3,
      6073: 4,
      2: 5,
      3: 6,

      4: 7,
      5: 8,
      6: 9,
      7: 10,
      8: 11,

      9:12,
      10:13,
      14:14,
      15:15,
      16:16,
      17:17,
      19:18,
      20:19,
      21:20,
      22:21,
      23:22,
      24:23,
      25:24,


    };
    const tab_one_cur = ref(0);
    const tab_two_cur = ref(-1);
    const nodes_list = ref([]);
    const video_list = ref([]);
    const cur_page = ref(1);
    const total_page = ref(1);
    let promise_method =
      props.route_type == "drive" ? getParentNodes : getParentNodes2;
    promise_method().then((res) => {
      nodes_list.value = res.data;
      getVideos();
    });

    const getVideos = () => {
      let node_id =
        tab_two_cur.value > -1
          ? nodes_list["value"][tab_one_cur.value]["child"][tab_two_cur.value][
              "node_id"
            ]
          : nodes_list["value"][tab_one_cur.value]["node_id"];
      let promise_method2 =
        props.route_type == "drive" ? getNodeVideos : getNodeVideos2;
      promise_method2({
        node_id,
        page: cur_page.value,
        size: 12,
      }).then((res) => {
        video_list.value = [...video_list.value, ...res.data.list];
        cur_page.value = cur_page.value + 1;
        total_page.value = res.data.total_page;
      });
    };
    const changeCurInd = (ind) => {
      video_list.value = [];
      cur_page.value = 1;
      total_page.value = 1;
      tab_one_cur.value = ind;
      tab_two_cur.value = -1;
      getVideos();
    };
    const changeCurInd2 = (ind) => {
      video_list.value = [];
      cur_page.value = 1;
      total_page.value = 1;
      tab_two_cur.value = ind;
      getVideos();
    };

    const video_src = ref("");
    const video_show = ref(false);
    const playVideo = (video_obj) => {
      video_src.value = props.route_type=='drive'?video_obj.attach_value:video_obj.link_url;
      video_show.value = true;
    };
    const stopVideo = () => {
      video_src.value = "";
      video_show.value = false;
    };

    return {
      nodes_type,
      nodes_list,
      tab_one_cur,
      tab_two_cur,
      changeCurInd,
      changeCurInd2,
      video_list,
      stopVideo,
      playVideo,
      video_src,
      video_show,
      cur_page,
      total_page,
      getVideos
    };
  },
};
</script>

<style lang="less" scoped>
.scenario_container {
  // height: calc(100vh - 133px);
  display: flex;
  flex-direction: column;
}
.parent_nodes {
  width: 1104px;
  background: #ffffff;
  border-radius: 6px;
  padding: 23px 0 10px 47px;
  flex-wrap: wrap;
  .parent_node {
    width: 186px;
    height: 45px;
    border-radius: 4px;
    color: #515151;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
    margin-bottom: 17px;
    &:not(.act):hover {
      background: #e5f1ff;
    }
    .icon {
      width: 45px;
      height: 45px;
      &.icon_1 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/che_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_2 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/fxp_hei.png)
          no-repeat center center;
        background-size: 22px;
      }
      &.icon_3 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/tc_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_4 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/dms_hei.png)
          no-repeat center center;
        background-size: 21px;
      }
      &.icon_5 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/nsbt_hei.png)
          no-repeat center center;
        background-size: 16px;
      }
      &.icon_6 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/zkp_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_7 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/app_hei.png)
          no-repeat center center;
        background-size: 16px;
      }
      &.icon_8 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/ybp_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_9 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/fxp2_hei.png)
          no-repeat center center;
        background-size: 19px;
      }
      &.icon_10 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/fjp_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_11 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/hpp_hei.png)
          no-repeat center center;
        background-size: 20px;
      }

      &.icon_12 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/nsbt_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_13 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/sy_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_14 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/dh_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_15 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/dmt_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_16 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/kt_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_17 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/yx_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_18 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/fwd_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_19 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/cjms_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_20 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/ylyy_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_21 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/hscfw_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_22 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/gxh_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_23 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/yysc_hei.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_24 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/yhsc_hei.png)
          no-repeat center center;
        background-size: 20px;
      }

    }
    &.act {
      background: #1FBCBF;
      color: #fff;
      .icon {
        width: 45px;
        height: 45px;
        &.icon_1 {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/che_bai.png)
            no-repeat center center;
          background-size: 20px;
        }
        &.icon_2 {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/fxp_bai.png)
            no-repeat center center;
          background-size: 22px;
        }
        &.icon_3 {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/tc_bai.png)
            no-repeat center center;
          background-size: 20px;
        }
        &.icon_4 {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/dms_bai.png)
            no-repeat center center;
          background-size: 21px;
        }
        &.icon_5 {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/nsbt_bai.png)
            no-repeat center center;
          background-size: 16px;
        }
        &.icon_6 {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/zkp_bai.png)
            no-repeat center center;
          background-size: 20px;
        }
        &.icon_7 {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/app_bai.png)
            no-repeat center center;
          background-size: 16px;
        }
        &.icon_8 {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/ybp_bai.png)
            no-repeat center center;
          background-size: 20px;
        }
        &.icon_9 {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/fxp2_bai.png)
            no-repeat center center;
          background-size: 19px;
        }
        &.icon_10 {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/fjp_bai.png)
            no-repeat center center;
          background-size: 20px;
        }
        &.icon_11 {
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/hpp_bai.png)
            no-repeat center center;
          background-size: 20px;
        }

        &.icon_12 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/nsbt_bai.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_13 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/sy_bai.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_14 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/dh_bai.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_15 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/dmt_bai.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_16 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/kt_bai.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_17 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/yx_bai.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_18 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/fwd_bai.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_19 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/cjms_bai.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_20 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/ylyy_bai.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_21 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/hscfw_bai.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_22 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/gxh_bai.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_23 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/yysc_bai.png)
          no-repeat center center;
        background-size: 20px;
      }
      &.icon_24 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/yhsc_bai.png)
          no-repeat center center;
        background-size: 20px;
      }
      }
    }
  }
}

.nodes_container {
  flex-grow: 1;
  margin-top: 20px;
  padding: 0 0 20px 47px;
  width: 1104px;
  background: #ffffff;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .node_tabs {
    position: sticky;
    top: 0;
    background: #fff;
    flex-shrink: 0;
    flex-wrap: wrap;
    min-height: 90px;
    padding-top: 35px;
    padding-bottom: 10px;
    z-index: 1;
    .node_tab {
      margin-right: 8px;
      padding: 0 16px;
      height: 32px;
      line-height: 32px;
      color: #050505;
      cursor: pointer;
      &.act {
        background: #1FBCBF;
        border-radius: 4px;
        color: #fff;
      }
    }
  }
  .videos_box{
    height: calc(100% - 80px);
    overflow-y: auto;
    margin-right: 10px;
    padding-bottom: 10px;
  }
  .node_videos {
    flex-wrap: wrap;
    .node_video {
      width: 236px;
      margin-right: 20px;
      margin-bottom: 34px;
      cursor: pointer;
      .video_box {
        width: 100%;
        height: 133px;
        background: #d8d8d8;
        border-radius: 6px;
        overflow: hidden;
        video {
          width: 100%;
          height: 100%;
        }
      }
      .node_name {
        margin-top: 11px;
        font-size: 14px;
        font-weight: bold;
        color: #474747;
        line-height: 19px;
      }
      .model_name {
        margin-top: 8px;
        font-size: 12px;
        color: #474747;
        line-height: 16px;
        align-items: center;
        .brand_logo {
          width: 26px;
          height: 26px;
          border: 1px solid #dfdfdf;
          border-radius: 13px;
          margin-right: 5px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }
  }
  .load_more {
    width: 200px;
    margin: 0 auto;
    text-align: center;
    color: #1FBCBF;
    cursor: pointer;
  }
  .no_more{
    width: 200px;
    margin: 0 auto;
    text-align: center;
    color: #ccc;
  }
}
.video_pop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 5000;
  .video_content {
    width: 100%;
    height: 100%;
    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .video_close {
      width: 50px;
      height: 50px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/a467vc54678bvt67bv.png)
        no-repeat center center;
      background-size: 50px 50px;
      border-radius: 50%;
      cursor: pointer;
      position: absolute;
      right: 50px;
      top: 50px;
    }
  }
}
</style>